import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material'
import { useField } from 'formik'
import { forwardRef, InputHTMLAttributes, useMemo, useState } from 'react'

interface TextfieldWrapperProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string
}

type Props = TextFieldProps & TextfieldWrapperProps

const TextfieldWrapper = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const [field, meta] = useField(props.name)
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const configTextfield = useMemo(() => {
    const config = {
      ...field,
      ...props,
      fullWidth: true,
      name: field.name || '',
      ref,
      value: field.value || '',
      variant: 'outlined',
      ...(props.type === 'password' && {
        InputProps: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                edge="end"
                onClick={handleClickShowPassword}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        },
        type: showPassword ? 'text' : 'password',
      }),
    } as TextFieldProps

    if (meta && meta.touched && meta.error) {
      return {
        ...config,
        error: true,
        helperText: meta.error,
      }
    }

    return config
  }, [field, meta, props, showPassword])

  return <TextField {...configTextfield} />
})

export default TextfieldWrapper
